import React from "react";

import "./InputField.scss";
import { exclamationCircle } from "../../CalculatorTool/Icons";

interface InputFieldPropsInterface {
  readonly id: string;
  readonly name: string;
  readonly type: "text" | "email" | "search" | "tel" | "url" | "number";
  readonly label: string;
  readonly isRequired: boolean;
  readonly isInvalid: boolean;
  readonly className?: string;
  readonly placeholder?: string;
  readonly validationMessages?: string;
  readonly value?: string;
  readonly isAutoFocus?: boolean;
  readonly reference?: React.LegacyRef<HTMLInputElement>;
  onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldPropsInterface> = (props) => {
  const {
    id,
    name,
    className,
    type,
    label,
    isRequired,
    placeholder,
    onChangeHandler,
    validationMessages,
    isInvalid,
    value,
    isAutoFocus,
    reference
  } = props;
  return (
    <>
      <label className={isInvalid ? "invalid-label" : ""} htmlFor={id}>
        {label}
      </label>
      <input
        type={type}
        id={id}
        className={className}
        name={name}
        placeholder={placeholder}
        autoComplete="off"
        onChange={onChangeHandler}
        aria-invalid={isInvalid}
        aria-required={isRequired}
        aria-describedby={isInvalid ? 'alert-'+id : ''}
        value={value}
        autoFocus={isAutoFocus}
        ref={reference}
      />
      <div className="validation-message" style={{ display: isRequired && isInvalid ? 'block' : 'none' }}>
        <span>{exclamationCircle}</span>
        <span role="alert" id={'alert-'+id}>{validationMessages}</span>
      </div>
    </>
  );
};

export default InputField;
